const AUTHENTICATION_VARIRABLES = {
    USER_IDLE_TIMEOUT_MINUTES: 1440, //24 hours
    CLIENT_NAME: 'gaf-identity-client'
};

module.exports = { AUTHENTICATION_VARIRABLES };
